import { ClockIcon } from '@heroicons/react/24/outline';
import { ExternalLink } from 'lucide-react';
import {
  LastEscalationValue,
  useLastEscalationInfo,
} from '../last-escalation-info/LastEscalationInfo';
import { MUTED_ICON_CLASS } from './sop-card-utils';
import { CollapsibleCard } from './CollapsibleCard';

interface Props {
  locationId: string;
}

export function LastEscalatedCard({ locationId }: Props) {
  const info = useLastEscalationInfo(locationId);

  return (
    <CollapsibleCard
      variant="surface"
      title="Last Escalated"
      icon={<ClockIcon className={MUTED_ICON_CLASS} />}
      titleAfter={<LastEscalationValue info={info} showTooltip={false} />}
      headerAction={
        info.href && (
          <a
            href={info.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="text-onlight-text-2 dark:text-ondark-text-2 hover:text-onlight-text-1 dark:hover:text-ondark-text-1"
          >
            <ExternalLink className="h-4 w-4" />
          </a>
        )
      }
      collapsible={!!info.description}
      defaultExpanded={false}
      bodyGap={info.description ? undefined : ''}
    >
      {info.description && (
        <p className="text-onlight-text-2 dark:text-ondark-text-2 px-1 text-xs [overflow-wrap:anywhere]">
          {info.description}
        </p>
      )}
    </CollapsibleCard>
  );
}

export default LastEscalatedCard;
